<template>
  <div class="p-5">
    <spinner v-if="loading"></spinner>

    <no-contacts-message v-else-if="contacts.length === 0" class="my-5"></no-contacts-message>

    <div v-else>
      <table class="table table-hover table-responsive-md">
        <thead>
        <tr>
          <th>Name</th>
          <th>Id</th>
          <th v-if="showGender">Gender</th>
          <th v-if="showLocale">Locale</th>
          <th v-if="showTimeZone">Time Zone</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="contact in contacts" :key="contact.id">
          <td>{{contact.name}}</td>
          <td>{{contact.id}}</td>
          <td v-if="showGender">{{contact.gender}}</td>
          <td v-if="showLocale">{{contact.locale}}</td>
          <td v-if="showTimeZone">{{contact.time_zone}}</td>
          <td class="text-right">
            <a href="#" role="button" @click="openDeleteConfirm(contact)">
              <icon class="btn-icon text-danger" name="trash" scale="1.0"/>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      <b-pagination v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="listMaxSize"
                    :hide-goto-end-buttons="hideGoToEndButtons"
                    @change="pageChanged">
      </b-pagination>
    </div>
    <modal-delete-contact
      :modalId="modalId"
      @contactDeleted="contactDeleted"
      :channel="channel"
      :contact="contactForDeletion">
    </modal-delete-contact>
  </div>
</template>

<script>
  import ConfirmDelete from '@/components/administration/channel/contacts/ConfirmDeleteContact'
  import NoContactsMessage from '@/components/administration/channel/contacts/components/NoContactsMessage'
  import {prepareChannel} from '@/components/administration/channel/router-guard-handler'
  import contactService from '@/services/amio-api/contact.service'
  import 'vue-awesome/icons/trash'
  import loadingMixin from '@/mixins/loading.mixin'

  export default {
    mixins: [loadingMixin],

    components: {
      'modal-delete-contact': ConfirmDelete,
      'no-contacts-message': NoContactsMessage
    },

    store: {
      channel: 'administration.channelDetail.channel'
    },

    data() {
      return {
        contacts: [],
        totalItems: null,
        listMaxSize: parseInt(process.env.VUE_APP_LIST_MAX_SIZE),
        currentPage: 1,
        promiseDeleteContact: {},
        modalId: 'delete-contact',
        contactForDeletion: {}
      }
    },

    computed: {
      showGender() {
        return ['facebook_messenger'].includes(this.channel.type)
      },

      showLocale() {
        return ['facebook_messenger', 'viber'].includes(this.channel.type)
      },

      showTimeZone() {
        return ['facebook_messenger'].includes(this.channel.type)
      },

      hideGoToEndButtons() {
        return this.totalItems < parseInt(process.env.VUE_APP_PAGINATION_ITEMS_SHOW_END_BUTTONS)
      }
    },

    methods: {
      setData({items, totalItems}) {
        this.contacts = items
        this.totalItems = totalItems
      },

      pageChanged(page) {
        this.currentPage = page
        this.$router.push({query: {page: page}})
        this.getContacts()
      },

      contactDeleted() {
        this.getContacts()
          .then(() => {
            // adjust pagination overflow - might happen when deleting
            if (this.contacts.length > 0 || this.currentPage <= 1) return

            return this.pageChanged(this.currentPage - 1)
          })
      },

      openDeleteConfirm(contact) {
        this.contactForDeletion = contact
        this.$root.$emit('bv::show::modal', this.modalId)
      },

      getContacts() {
        const page = this.$route.query.page ? parseInt(this.$route.query.page) : this.currentPage
        const offset = (page - 1) * this.listMaxSize
        this.loading = true
        return contactService.list(this.channel.id, {offset, max: this.listMaxSize})
          .then(this.setData)
          .then(() => {
            this.loading = false
            // set currentPage after totalItems are set due to b-pagination
            this.currentPage = page
          })
      }
    },

    mounted() {
      if (!this.channel.id) return

      this.getContacts()
    },

    beforeRouteEnter(to, from, next) {
      prepareChannel(to, next, vm => {
        vm.getContacts()
      })
    }
  }
</script>
